/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { EndDate } from '../models/EndDate';
import type { StartDate } from '../models/StartDate';
import type { VehicleData } from '../models/VehicleData';
import type { VehicleId } from '../models/VehicleId';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class EntriesService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Get last entries
     * Get last entries
     * @param vehicleId Vehicle ID
     * @param data Data entries
     * @param interval Last interval (sec)
     * @returns any OK
     * @throws ApiError
     */
    public entriesLast(
        vehicleId: VehicleId,
        data: Array<string>,
        interval: number,
    ): Observable<Array<{
        data: VehicleData;
        date: string;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/entries/last',
            query: {
                'vehicle_id': vehicleId,
                'data': data,
                'interval': interval,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Export all entries
     * Export vehicle entries
     * @param vehicleId Vehicle ID
     * @param startDate Start date
     * @param data Data to select
     * @param type Export format
     * @param endDate End date
     * @returns binary OK
     * @throws ApiError
     */
    public entriesExport(
        vehicleId: VehicleId,
        startDate: StartDate,
        data: Array<string>,
        type: 'xlsx' | 'csv',
        endDate?: EndDate,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/entries/export',
            query: {
                'vehicle_id': vehicleId,
                'start_date': startDate,
                'end_date': endDate,
                'data': data,
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                413: `Export data too large`,
                500: `Server error`,
                504: `Server error`,
            },
        });
    }
    /**
     * Get all entries
     * Get all entries
     * @param vehicleId Vehicle ID
     * @param startDate Start date
     * @param data Data to select
     * @param endDate End date
     * @returns any OK
     * @throws ApiError
     */
    public entries(
        vehicleId: VehicleId,
        startDate: StartDate,
        data: Array<string>,
        endDate?: EndDate,
    ): Observable<Array<{
        data: VehicleData;
        date: string;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/entries/',
            query: {
                'vehicle_id': vehicleId,
                'start_date': startDate,
                'end_date': endDate,
                'data': data,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
